
export const getAgeStringFromMonths = months => {
  if (!Number.isInteger(months)) return '';
  if (months === 1) return '1 month';
  if (months < 24) return '' + months + ' months';
  if (months < 60) {
    const remainder = months % 12;
    const years = Math.floor(months / 12);
    return years + ' yr, ' + remainder + ' mnth';
  }
  const years = Math.round(months / 12);
  return years + ' years';
};

const monthsFromJsDate = d => {
  const today = new Date();
  let months = (today.getFullYear() - d.getFullYear()) * 12;
  months -= d.getMonth();
  months += today.getMonth();
  return months <= 0 ? 0 : months;
};

export const monthsFromDate = dateStr => {
  const d = new Date(dateStr);
  return monthsFromJsDate(d);
};

export const monthsStringFromDate = dateStr => {
  const m = monthsFromDate(dateStr);
  return m === 1 ? `${m} month old` : `${m} months old`;
};

export const ageFromDateString = dateStr => {
  const months = monthsFromDate(dateStr);
  return getAgeStringFromMonths(months) + ' old';
};

const dateFromUKDate = ukDateStr => {
  const year = ukDateStr.substring(6, 10);
  const month = ukDateStr.substring(3, 5);
  const day = ukDateStr.substring(0, 2);
  return new Date(year, parseInt(month) - 1, day);
};

export const timeFromUkDateString = ukDateStr => {
  const date = dateFromUKDate(ukDateStr);
  const dateStr = date.toISOString();
  const months = monthsFromDate(dateStr);
  if (months === 0) return 'less than a month';
  return getAgeStringFromMonths(months);
};

const dateFromStr = dateStr => {
  return new Date(dateStr);
};

export const videoTitleString = (videoDate, dob) => {
  const filmAge = timeFromUkDateString(videoDate);
  const msSinceFilming =
    new Date().getTime() - dateFromUKDate(videoDate).getTime();
  const adjustedDobMs = dateFromStr(dob).getTime() + msSinceFilming;
  const months = monthsFromJsDate(new Date(adjustedDobMs));
  const ageAtFilming = getAgeStringFromMonths(months);
  return `Filmed ${filmAge} ago at ${ageAtFilming} old`;
};

export const dueInXMonths = d => {
  const today = new Date();
  let months = (today.getFullYear() - d.getFullYear()) * 12;
  months -= d.getMonth();
  months += today.getMonth();
  return `due in ${Math.abs(months)} months`;
};

export const timeFromNow = time => {
  const now = new Date().getTime();
  // Get timestamps
  const unixTime = new Date(time).getTime();
  if (!unixTime) return;

  // Calculate difference
  let difference = (unixTime / 1000) - (now / 1000);

  // Setup return object
  const tfn = {};

  // Check if time is in the past, present, or future
  tfn.when = 'now';
  if (difference > 0) {
    tfn.when = 'future';
  } else if (difference < -1) {
    tfn.when = 'past';
  }

  // Convert difference to absolute
  difference = Math.abs(difference);

  // Calculate time unit
  if (difference / (60 * 60 * 24 * 365) > 1) {
    // Years
    tfn.unitOfTime = 'year';
    tfn.time = Math.round(difference / (60 * 60 * 24 * 365));
  } else if (difference / (60 * 60 * 24 * 365 / 12) > 1) {
    // Months
    tfn.unitOfTime = 'month';
    tfn.time = Math.round(difference / (60 * 60 * 24 * 365 / 12));
  } else if (difference / (60 * 60 * 24 * 7) > 1) {
    // Weeks
    tfn.unitOfTime = 'week';
    tfn.time = Math.round(difference / (60 * 60 * 24 * 7));
  } else if (difference / (60 * 60 * 24) > 1) {
    // Days
    tfn.unitOfTime = 'day';
    tfn.time = Math.round(difference / (60 * 60 * 24));
  } else if (difference / (60 * 60) > 1) {
    // Hours
    tfn.unitOfTime = 'hour';
    tfn.time = Math.round(difference / (60 * 60));
  } else if (difference / 60 > 1) {
    // Hours
    tfn.unitOfTime = 'minute';
    tfn.time = Math.round(difference / 60);
  } else {
    // Seconds
    tfn.unitOfTime = 'second';
    tfn.time = Math.round(difference);
  }

  // Return time from now data
  // eslint-disable-next-line max-len
  return `${tfn.when === 'future' ? 'in ' : ''}${tfn.time} ${tfn.unitOfTime}${tfn.time > 1 ? 's' : ''} ${tfn.when === 'future' ? '' : 'ago'}`;
};
